<template>
    <svg-vue :icon="path" :key="brand" aria-hidden="true" />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
    brand?: string;
}>();

const path = computed(() => `payments/${props.brand}`);
</script>
